import { useState } from "react";

import { Button } from "components/Button/index";
import { RecommendedStrategyModal } from "shared/Modal/RecommendModal/GetStartedModal/index";
import { QuestionModal } from "shared/Modal/RecommendModal/QuestionModal/index";
import { useQuestionnaireAnswers } from "shared/hooks/useQuestionnaireAnswers";
import { RecommendStrategyResultModal } from "shared/Modal/RecommendModal/RecommendStrategyResult/index";

export const RecommendedButton = () => {
  const [showResultModal, setShowResultModal] = useState(false);
  const [showRecommendedModal, setShowRecommendedModal] = useState(false);
  const [showQuestionModal, setShowQuestionModal] = useState(false);

  const {
    isLoading,
    reviewQuestionChoice,
    strategies,
    hasAnswers,
    refetchAnswers,
  } = useQuestionnaireAnswers({ enabled: showQuestionModal });

  const handleRecommendedClick = async () => {
    if (hasAnswers) {
      toggleResultModal();
      return;
    }

    toggleRecommendedModal();
  };

  const toggleResultModal = () => {
    setShowResultModal(!showResultModal);
  };

  const handleRecommendStrategyResultView = () => {
    toggleResultModal();
  };

  const handleGetStart = () => {
    toggleQuestionModal();
    setShowRecommendedModal(false);
  };

  const handleSubmit = async () => {
    await refetchAnswers();
    toggleResultModal();
  };

  const handleReviewAgain = () => {
    toggleResultModal();
    toggleQuestionModal();
  };

  const toggleRecommendedModal = () => {
    setShowRecommendedModal(!showRecommendedModal);
  };

  const toggleQuestionModal = () => {
    setShowQuestionModal(!showQuestionModal);
  };

  return (
    <>
      <Button
        className="btn-find"
        disabled={isLoading}
        onClick={handleRecommendedClick}
      >
        {isLoading ? "Loading..." : "Find Recommended Strategy"}
      </Button>

      {showResultModal && (
        <RecommendStrategyResultModal
          show={showResultModal}
          onHide={toggleResultModal}
          handleDone={handleRecommendStrategyResultView}
          handleReviewAgain={handleReviewAgain}
          strategies={strategies}
        />
      )}

      {showRecommendedModal && (
        <RecommendedStrategyModal
          show={showRecommendedModal}
          onHide={toggleRecommendedModal}
          handleGetStart={handleGetStart}
        />
      )}

      {showQuestionModal && (
        <QuestionModal
          show={showQuestionModal}
          onHide={toggleQuestionModal}
          onSuccess={handleSubmit}
          reviewQuestionChoice={reviewQuestionChoice}
        />
      )}
    </>
  );
};
